const fakeAnalysis = {
  lineData: {
    xAxis: {
      labels: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
    },
    series: {
      ingresos: [1200, 2340, 3100, 2900, 4100, 3780, 1200, 980, 1100, 0, 0, 0],
      egresos: [300, 540, 700, 650, 1000, 900, 300, 250, 300, 0, 0, 0],
      ganancias: [900, 1800, 2400, 2250, 3100, 2880, 900, 730, 800, 0, 0, 0],
    },
  },
  barData: {
    xAxis: {
      employees: ["Luis Janco", "Oscar Arze", "Aaron Salas", "Jose Quispe", "Ilse Romero"],
    },
    series: {
      servicios: [35, 28, 22, 19, 14],
      calificacion: [4.5, 4.2, 4.0, 3.8, 4.3],
      retentionRate: [75, 60, 50, 45, 40],
    },
  },
  pieCharts: {
    totalDirectBookings: "1.00",
    totalRedirectBookings: "0.00",
    topServicesInBranch: [
      { label: "Corte", value: 50, averageAge: 25, percentage: 40 },
      { label: "Barba", value: 30, averageAge: 22, percentage: 24 },
      { label: "Coloración", value: 20, averageAge: 30, percentage: 16 },
      { label: "Otros", value: 25, averageAge: null, percentage: 20 },
    ],
    topServicesDomicilio: [
      { label: "Corte", value: 20, averageAge: 26, percentage: 50 },
      { label: "Coloración", value: 12, averageAge: 30, percentage: 30 },
      { label: "Otros", value: 8, averageAge: null, percentage: 20 },
    ],
    totalServicesInBranch: [
      { label: "Corte", value: 70, averageAge: 25, percentage: 38 },
      { label: "Barba", value: 40, averageAge: 22, percentage: 22 },
      { label: "Coloración", value: 30, averageAge: 30, percentage: 16 },
      { label: "Peinado", value: 20, averageAge: 24, percentage: 11 },
      { label: "Otros", value: 25, averageAge: null, percentage: 13 },
    ],
    totalServicesDomicilio: [
      { label: "Corte", value: 30, averageAge: 26, percentage: 42 },
      { label: "Coloración", value: 20, averageAge: 30, percentage: 28 },
      { label: "Peinado", value: 10, averageAge: 24, percentage: 14 },
      { label: "Otros", value: 11, averageAge: null, percentage: 16 },
    ],
  },
  totalServicios: 340,
  topCustomers: [
    { fullName: "Pedro Paredes", phone: "70000001", _id: "1", totalServices: 40 },
    { fullName: "Juan Pérez", phone: "70000002", _id: "2", totalServices: 35 },
    { fullName: "Ana García", phone: "70000003", _id: "3", totalServices: 30 },
    { fullName: "Luis Janco", phone: "70000004", _id: "4", totalServices: 28 },
    { fullName: "Camila Soliz", phone: "70000005", _id: "5", totalServices: 25 },
  ],
  totalEgresos: 4940,
  totaIngresos: 20600,
  totalGanancias: 15660,
};

export default fakeAnalysis;
